// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legal-section-headline[data-v-1de0c3d7]{counter-increment:legalSection}.legal-section-headline[data-v-1de0c3d7]:before{content:\"§\" counter(legalSection) \" \"}@media (max-width:600px){a[data-v-1de0c3d7]{word-break:break-all!important}}", ""]);
// Exports
module.exports = exports;
